const FAQ_ITEMS = [
  {
    id: 1,
    q: '17吃瓜网是什么？',
    a: '17吃瓜网是国内领先的娱乐资讯与吃瓜资源聚合平台，提供每日最新黑料、明星八卦、网红翻车、综艺内幕等海量内容。支持网页端和APP端浏览，是17一起吃瓜网的官方品牌站点。',
  },
  {
    id: 2,
    q: '17吃瓜网的内容多久更新一次？',
    a: '平台实行7×24小时不间断更新机制，编辑团队全天候追踪全网热点。平均每日新增50条以上经过核实的吃瓜内容，确保瓜友第一时间获取最新资讯。',
  },
  {
    id: 3,
    q: '如何下载17吃瓜APP？',
    a: '您可以在本页面的"APP下载"区域找到iOS和Android的下载入口，也可以通过各大应用商店搜索"17吃瓜"进行下载。APP端支持离线缓存、实时推送和夜间模式等专属功能。',
  },
  {
    id: 4,
    q: '平台上的爆料内容可信吗？',
    a: '17吃瓜网始终坚持"多源交叉验证"原则，所有爆料内容在发布前都会经过编辑团队的多方核实。对于尚未完全确认的信息，我们会在标题和正文中明确标注"待证实"，确保信息的透明度。',
  },
  {
    id: 5,
    q: '我可以向17吃瓜网投稿吗？',
    a: '当然可以！我们欢迎每一位瓜友的投稿与爆料。您可以通过页面底部的投稿邮箱、官方微信等渠道联系我们的编辑团队。我们承诺严格保护爆料人隐私信息。',
  },
  {
    id: 6,
    q: '17吃瓜网和17一起吃瓜网是什么关系？',
    a: '17吃瓜网是品牌官方主站，17一起吃瓜网是同一品牌下的社区化内容共创平台。两者内容互通、账号打通，用户可以在两个平台之间无缝切换浏览。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            帮助中心
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            常见问题
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {FAQ_ITEMS.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-100/50 transition-colors list-none">
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 flex-shrink-0 text-lg"></i>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}